// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { setNestedInReduxState } from 'redux/helpers'
import initialState from './initialState'

import {
  SET_PROJECTS_DATA,
  SET_SITES_DATA,
  // SET_PANORAMA_DATASET_PROJECTS_DATA,
  // SET_MODEL_DATASET_PROJECTS_DATA,
  // SET_VIDEO_DATASET_PROJECTS_DATA,
  // SET_DESIGN_OVERLAY_DATASET_PROJECTS_DATA,
} from './types'

const rfDroneServices = (state = initialState, action) => {
  switch (action.type) {
    case SET_PROJECTS_DATA :
      return setNestedInReduxState(
        state,
        'projects',
        {
          ...state.projects,
          data: action.data,
          dataExpiration: action.dataExpiration,
        }
      )

    case SET_SITES_DATA :
      return setNestedInReduxState(
        state,
        'sites',
        {
          ...state.sites,
          data: action.data,
          dataExpiration: action.dataExpiration,
          projectId: action.projectId,
        }
      )

    default :
      return state
  }
}

export default rfDroneServices
